import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
`

export const Label = styled.label`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: var(--foreground-neutral, #14171f);
`

export const LabelOptional = styled.label`
  color: var(--foreground-neutral-faded, var(--foreground-neutral-faded, #4d5874));

  /* Body 3/Regular */
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
`

export const TextInputContainer = styled.div<{ error?: boolean; disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  overflow: hidden;

  border: 1px solid
    ${({ disabled, error }) =>
      disabled
        ? 'var(--Background-Neutral-faded, #f3f4f6)'
        : error
        ? 'var(--border-critical, #CB101D)'
        : 'var(--border-neutral, #bbc1d3)'};
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;
  height: 36px;

  background: ${({ disabled }) =>
    disabled ? 'var(--Background-Neutral-faded, #f3f4f6)' : 'var(--background-elevation-base, #fff)'};

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    height: 48px;
  }

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    padding: 12px 16px;
    height: 48px;
  }
`

export const TextInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  color: var(--foreground-neutral, #14171f);
  line-height: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding: 0;

  ::placeholder {
    color: var(--foreground-neutral-faded, #4d5874);
    opacity: 0.5;
  }

  background-color: white;

  :disabled {
    background: var(--Background-Neutral-faded, #f3f4f6);
  }

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    font-size: 16px;
  }
`

export const NumberIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 18px;
  height: 18px;

  border-radius: 6px;
  background: var(--background-neutral, #dfe2ea);

  color: var(--foreground-neutral-faded, #4d5874);

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`

export const LabelHint = styled.label<{ error?: boolean }>`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: ${({ error }) => (error ? 'var(--foreground-critical, #CB101D)' : 'var(--foreground-neutral-faded, #4D5874)')};
  line-height: 20px;
`
